import { render, staticRenderFns } from "./homeCard.vue?vue&type=template&id=f28e1d14&scoped=true"
import script from "./homeCard.vue?vue&type=script&lang=js"
export * from "./homeCard.vue?vue&type=script&lang=js"
import style0 from "./homeCard.vue?vue&type=style&index=0&id=f28e1d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e1d14",
  null
  
)

export default component.exports